export default __webpack_public_path__ + "media/images/zoom_out-0f2ec1989692c944fd17df9c21376080.png";